import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginComponent } from '../../login/login.component';
import { ForgotPasswordComponent } from '../../login/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../../login/reset-password/reset-password.component';
import { BmsjHipsterSharedModule } from '../shared.module';
import { OneTimePasswordComponent } from '../../login/one-time-password/one-time-password.component';
import { LoginService } from './login.service';
import { LoginContext } from './login-context';
import { AuthorizeLoginComponent } from '../../login/authorize-login/authorize-login.component';
import { LanguangeSelectorComponent } from '../languange-selector/languange-selector.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule,
        LanguangeSelectorComponent
    ],
    declarations: [
        LoginComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        OneTimePasswordComponent,
        AuthorizeLoginComponent
    ],
    providers: [
        LoginService,
        LoginContext
    ]
})
export class LoginModule {
}
